/**
 * Chakra-UI Default tabs colorScheme is blue. Any "invalid" colorScheme forces the tab to render black. Don't know why Chakra-UI doesn't have a black by default. blackAlpha renders a gray selected tab
 * Setting the colors in the base style as black won't override the default color scheme of blue
 * */
export const Tabs = {
  baseStyle: {
    tab: {
      pl: '0',
      pr: '0',
      minW: '100px',
      mr: 10,
      mt: 10,
      _selected: {
        fontWeight: 'bold',
        borderBottom: '2px',
      },
    },
  },
} as const;
